if (typeof CartRemoveButton !== 'function') {
	class CartRemoveButton extends HTMLElement {
		constructor() {
			super();

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.addEventListener('click', (event) => {
				event.preventDefault();

				const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

				cartItems.updateQuantity(this.dataset.index, 0);
			});
		}
	}

	if (!customElements.get('cart-remove-button')) {
		customElements.define('cart-remove-button', CartRemoveButton);
	}
}
if (typeof CartItems !== 'function') {
	class CartItems extends HTMLElement {
		constructor() {
			super();

			this.lineItemStatusElement =
				document.getElementById('shopping-cart-line-item-status') ||
				document.getElementById('CartDrawer-LineItemStatus');

			this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
				(total, quantityInput) => total + parseInt(quantityInput.value),
				0
			);

			this.debouncedOnChange = debounce((event) => {
				this.onChange(event);
			}, 300);

			this.addEventListener('change', this.debouncedOnChange.bind(this));
		}

		onChange(event) {
			if (!event.target.classList.contains('quantity-input')) return;

			this.updateQuantity(
				event.target.dataset.index,
				event.target.value,
				document.activeElement.getAttribute('name'),
				event.target.dataset.quantityVariantId
			);
		}

		getSectionsToRender() {
			return [
				{
					id: 'cart',
					section: document.getElementById('cart').dataset.id,
					selector: '.js-contents',
				},
				{
					id: 'cart-bubble',
					section: 'cart-bubble',
					selector: '#cart-bubble',
				},
				{
					id: 'cart-bubble__mobile',
					section: 'cart-bubble-mobile',
					selector: '#cart-bubble__mobile',
				},
			];
		}

		updateQuantity(line, quantity, name, variantId) {
			this.enableLoading(line);

			const body = JSON.stringify({
				line,
				quantity,
				sections: this.getSectionsToRender().map((section) => section.section),
				sections_url: window.location.pathname,
			});

			fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
				.then((response) => {
					return response.text();
				})
				.then((state) => {
					const parsedState = JSON.parse(state);
					const quantityElement =
						document.getElementById(`Quantity-${line}`) ||
						document.getElementById(`Drawer-quantity-${line}`);
					const items = document.querySelectorAll('.cart-item');

					if (parsedState.errors) {
						quantityElement.value = quantityElement.getAttribute('value');

						this.updateLiveRegions(line, parsedState.errors);

						return;
					}

					this.classList.toggle('is-empty', parsedState.item_count === 0);

					const cartDrawerWrapper = document.querySelector('cart-drawer');
					const cartFooter = document.getElementById('main-cart-footer');

					if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
					if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

					this.getSectionsToRender().forEach((section) => {
						const elementToReplace =
							document.getElementById(section.id).querySelector(section.selector) ||
							document.getElementById(section.id);

						elementToReplace.innerHTML = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
					});

					const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

					let message = '';

					if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
						if (typeof updatedValue === 'undefined') {
							message = window.cartStrings.error;
						} else {
							message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
						}
					}

					this.updateLiveRegions(line, message);

					const cartEvent = new CustomEvent(THEME_EVENTS.cartUpdate, {
						bubbles: true,
						detail: {
							variantId: variantId,
							cart: parsedState,
						},
					});

					document.dispatchEvent(cartEvent);
				})
				.catch((error) => {
					this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
					const errors =
						document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

					if (errors) {
						errors.textContent = window.cartStrings.error;
					}
				})
				.finally(() => {
					const imagesEvent = new CustomEvent('lazy-image:reload', {
						bubbles: true,
						detail: this,
					});

					document.dispatchEvent(imagesEvent);

					this.disableLoading(line);
				});
		}

		updateLiveRegions(line, message) {
			const lineItemError =
				document.getElementById(`Line-item-error-${line}`) ||
				document.getElementById(`CartDrawer-LineItemError-${line}`);
			if (lineItemError) {
				lineItemError.toggleAttribute('hidden', !message);
				lineItemError.querySelector('.cart-form__error-text').innerHTML = message;
			}

			this.lineItemStatusElement.setAttribute('aria-hidden', true);
		}

		getSectionInnerHTML(html, selector = '.shopify-section') {
			return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
		}

		enableLoading() {
			const overlay = this.querySelector('.loading-overlay');

			overlay.classList.remove('hidden');
			document.activeElement.blur();
			this.lineItemStatusElement.setAttribute('aria-hidden', false);
		}

		disableLoading(line) {
			const overlay = this.querySelector('.loading-overlay');

			overlay.classList.add('hidden');
		}
	}

	class CartDrawerItems extends CartItems {
		getSectionsToRender() {
			return [
				{
					id: 'cart-drawer',
					section: 'cart-drawer',
					selector: '.drawer-inner',
				},
				{
					id: 'cart-bubble',
					section: 'cart-bubble',
					selector: '#cart-bubble',
				},
				{
					id: 'cart-bubble__mobile',
					section: 'cart-bubble-mobile',
					selector: '#cart-bubble__mobile',
				},
			];
		}
	}

	if (!customElements.get('cart-items')) {
		customElements.define('cart-items', CartItems);
	}

	if (!customElements.get('cart-drawer-items')) {
		customElements.define('cart-drawer-items', CartDrawerItems);
	}
}

if (typeof CartNote !== 'function') {
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });

					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	if (!customElements.get('cart-note')) {
		customElements.define('cart-note', CartNote);
	}
}
